import { hash } from '@ember/helper';
import { on } from '@ember/modifier';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import FlashMessage from 'ember-cli-flash/components/flash-message';
import svgJar from 'ember-svg-jar/helpers/svg-jar';
import { eq } from 'ember-truth-helpers';

import { getBem } from 'umg-ember-backend/utils/get-bem';

import ApiError from './api-error';
import Default from './default';
import styles from './styles.module.css';

const bem = getBem(styles);

export default class ApplicationFlashMessagesComponent extends Component {
  // Services
  @service flashMessages;

  // Functions
  getFlashComponent = (componentName = 'default') => {
    const flashComponents = {
      'default': Default,
      'api-error': ApiError,
    };

    return flashComponents[componentName];
  };

  // Template
  <template>
    <div class={{(bem)}} ...attributes>
      {{! eslint-disable-next-line no-unused-vars }}
      {{#each this.flashMessages.queue as |flash|}}
        <FlashMessage
          @flash={{flash}}
          class={{bem 'message' (hash is-exiting=flash.exiting)}}
          @messageStylePrefix='type-'
          @timeout={{5000000}}
          as |flashMessage flash close|
        >
          {{#if (eq flash.type 'success')}}
            {{svgJar 'success' class=(bem 'icon')}}
          {{else}}
            {{svgJar 'error' class=(bem 'icon')}}
          {{/if}}

          <div class={{bem 'content'}}>
            {{#let
              (this.getFlashComponent flash.componentName)
              as |FlashComponent|
            }}
              <FlashComponent @flash={{flash}} @close={{close}} />
            {{/let}}

            {{#if flashMessage.showProgress}}
              <div class={{bem 'progress'}}>
                <div
                  class={{bem 'bar'}}
                  style={{flashMessage.progressDuration}}
                ></div>
              </div>
            {{/if}}
          </div>

          <div class={{bem 'close'}} {{on 'click' close}} role='button'>
            {{svgJar 'close' class='u-icon'}}
          </div>
        </FlashMessage>
      {{/each}}
    </div>
  </template>
}
